import { SearchHistory } from './types'

export const FACILITY_SEARCH_HISTORY_KEY = 'gyym:FacilitySearchHistory' as const

export const initialSearchHistory: SearchHistory = {
  facilityName: '',
  prefectureIds: [],
  activityIds: [],
  areaIds: [],
  sexLimitations: [],
  exerciseLevels: [],
  dates: [],
  startTimeFrom: null,
  startTimeTo: null,
  priceFrom: null,
  priceTo: null,
}
